define((require) => {
    "use strict";

    var Backbone = require("backbone");

    /**
     * Model representing metadata about an Product.
     *
     * @class SalesforceCommerceProductModel
     * @constructor
     */
    return Backbone.Model.extend({
        defaults: {
            name: null,
            productID: null,
            price: 0,
            image: null,
            brand: null,
            description: null,
            availability: null
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/model/SalesforceCommerceProductModel.js